import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class Point extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && v.valid() && !v.empty() ? serialize(Point, v) : SKIP;
            },
            (v) => {
                return deserialize(Point, v);
            }
        );
    }

    constructor(x = 0, y = 0) {
        super();
        this._x = x;
        this._y = y;
    }

    get x() {
        return this._x;
    }

    set x(value) {
        this._x = value;
    }

    get y() {
        return this._y;
    }

    set y(value) {
        this._y = value;
    }

    get string() {
        return "[" + this.x + ":" + this.y + "]";
    }

    equal(value) {
        if (value instanceof Point) {
            return this.x === value.x && this.y === value.y;
        }
        return false;
    }

    valid() {

        if (!Number.isInteger(this.x)) {
            return false;
        }

        if (!Number.isInteger(this.y)) {
            return false;
        }

        return true;
    }

    empty() {
        return this.x === 0 && this.y === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new Point());
        } else if (target instanceof Point) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(Point, {
    _x: alias("x", Schema.primitive()),
    _y: alias("y", Schema.primitive())
});